module.exports = __webpack_public_path__ + "static/media/Logo.9220a4f9.png";